import { useNavigate } from "react-router-dom";
import { useOrganization } from "../../../../../hooks/query";

export default function useCreateOrganization() {
    const navigate = useNavigate();
    const { useCreate } = useOrganization();

    const createOrganizationSvc = useCreate();

    const handleCreateOrganization = async (data: any) => {
        try {
            const { LogoFile: _logoFile, ...payload } = data;
            await createOrganizationSvc.mutateAsync(payload);
            setTimeout(() => {
                navigate("/admin/organizations");
            }, 1000);
        } catch (error) {
            console.error("Failed to create organization", error);
        }
    };

    return {
        createOrganizationSvc,
        handleCreateOrganization,
    };
}
